import { AvvirEvent } from "type_aliases";
import { ApiPlannedElement } from "avvir";

export type PlannedBuildingElementsLoadedEvent = AvvirEvent<typeof PLANNED_BUILDING_ELEMENTS_LOADED, { floorId: string, elements: ApiPlannedElement[], bulkIngest?: boolean }>

/**
 * `bulkIngest` is scaffolding for the bigBimMinimalPayload LaunchDarkly flag: it tells the reducers to
 * take the big-BIM bulk-ingest paths (accumulate into the store outside immer, and clear the minimal
 * payload's builtStatus) instead of the pre-big-BIM immer merge. Every dispatcher of this event sets it
 * from the flag, so with the flag off the payload keeps its original shape and the reducers behave
 * exactly as they did before big BIM. Once the flag is fully rolled out, drop the field and the legacy
 * reducer branches with it.
 */
const plannedBuildingElementsLoaded = (floorId: string, elements: ApiPlannedElement[], bulkIngest: boolean = false): PlannedBuildingElementsLoadedEvent => ({
  type: PLANNED_BUILDING_ELEMENTS_LOADED,
  payload: {
    floorId,
    elements,
    // Added only when set, so an unflagged dispatch is deep-equal to the pre-big-BIM payload.
    ...(bulkIngest ? { bulkIngest: true } : {})
  }
});

export const PLANNED_BUILDING_ELEMENTS_LOADED = "planned_building_elements_loaded";

export default plannedBuildingElementsLoaded;
